import { Directive, HostListener, Input } from '@angular/core';


/**------------------------------------------------------
 * Open File in new tab
 * --------------------
 * Opens a file like a PDF in a new tab
 *
 * Example:
 * --------
 * 	<button [ngOpenFile]="myFileData"> ... </button>
 */
@Directive({
    selector: '[ngOpenFile]',
    standalone: false
})
export class NgFileOpenDirective {

	@Input('ngOpenFile') data!: ArrayBuffer | string | Blob;

	@HostListener('click', ['$event'])
	public onClick(): void {

		//0 - check for data
		if (!this.data) throw new Error(`NgFileOpenDirective => onClick =>  FATAL ERROR: data was not provided`);

		//1 - create the link
		const link: HTMLAnchorElement = document.createElement('a');
		link.href   = window.URL.createObjectURL(this.data as Blob);
		link.target = '_blank';

		//2 - trigger the open
		link.click();
		link.remove();
	}
}
